<div class="card-group">
  <app-entrance-card [Users]="recentUsers" (ClickCard)="clickCard()" ></app-entrance-card>
</div>
